import api from './api';

export const discoveryService = {
  getSuggestedCreators: async (limit = 8) => {
    try {
      const response = await api.get('/discovery/suggestions', {
        params: { limit }
      });
      return response.data;
    } catch (error) {
      console.error('Failed to load suggested creators:', error);
      return [];
    }
  },

  getTrendingCreators: async (limit = 10) => {
    try {
      const response = await api.get('/discovery/trending', {
        params: { limit }
      });
      return response.data;
    } catch (error) {
      console.error('Failed to load trending creators:', error);
      return [];
    }
  },

  getNewCreators: async (limit = 10, page = 0) => {
    try {
      const response = await api.get('/discovery/new-creators', {
        params: { limit, page }
      });
      return response.data;
    } catch (error) {
      console.error('Failed to load new creators:', error);
      return [];
    }
  }
};
